import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, toRefs } from 'vue';
import { User } from '@/models/User';
import useUser from '@/mixins/useUser';
import MarvinInfoBox from '@/views/recommendations/components/MarvinInfoBox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendNotMatchingReasons',
  props: {
  notMatchingReasons: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  user: {
    type: Object as PropType<User>,
    default: null
  }
},
  setup(__props) {

const props = __props;



const { user, notMatchingReasons } = toRefs(props);

const { tUserFallback: t } = useUser(user);

const list = computed(() => `${notMatchingReasons.value?.map?.(
  (reason) => `- **${t(`recommendations.notMatchingReasons.${reason}`)}**`
).join('\n')}\n`);


return { __sfc: true,props, user, notMatchingReasons, t, list, MarvinInfoBox }
}

})